import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export const AdminNotifications = () => {
  const [d, setD] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState("");
  const apply = (x, keepEmail = false) => { setD(x); if (!keepEmail) setEmail(x.email || ""); };
  useEffect(() => { api.get("/admin/notifications").then((r) => apply(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async (events = d.events, mail = email) => {
    setBusy("save");
    try { apply((await api.put("/admin/notifications", { email: mail, events })).data, mail !== email); toast.success("Notification settings saved."); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const test = async (event) => {
    setBusy(event);
    try { const { data } = await api.post("/admin/notifications/test", { event }); toast.success(`Test sent to ${data.to}.`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  if (!d) return <div className="h-40 rounded-2xl shimmer" />;
  return (
    <section data-testid="admin-notifications" className="glass hairline-gold mt-6 rounded-2xl border p-5 sm:p-6">
      <p className="eyebrow">Notifications</p>
      <p className="mt-2 text-sm text-muted-foreground">Founder alerts from AetherTags &lt;noreply@aethertags.com&gt;, sent in the background. Failures show in the Email log.</p>
      <form onSubmit={(e) => { e.preventDefault(); save(); }} className="mt-4 flex flex-col gap-2 sm:flex-row">
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="founder@yourdomain.com"
          data-testid="admin-notify-email-input" className="h-11 rounded-xl sm:flex-1" />
        <Button type="submit" disabled={!!busy} data-testid="admin-notify-save" className="btn-aurora h-11 rounded-xl px-6">Save</Button>
      </form>
      <ul className="mt-5 divide-y divide-white/[0.06]">
        {Object.entries(d.labels).map(([k, label]) => {
          const live = d.live_events.includes(k);
          return (
            <li key={k} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`admin-notify-row-${k}`}>
              <label className="flex items-center gap-3 text-sm">
                <Switch checked={d.events[k]} onCheckedChange={(v) => save({ ...d.events, [k]: v }, d.email || "")} data-testid={`admin-notify-toggle-${k}`} aria-label={label} />
                <span>{label}</span>
                {!live && <span className="rounded-full border border-white/10 px-2 py-0.5 text-[11px] text-muted-foreground">Phase 2 · payments</span>}
              </label>
              <Button size="sm" variant="outline" disabled={!!busy || !d.email} onClick={() => test(k)} data-testid={`admin-notify-test-${k}`} className="min-h-[44px] rounded-full">
                {busy === k ? "Sending…" : "Send test"}
              </Button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
